import { z } from 'zod';

/////////////////////////////////////////
// NOTIFY GEOTARGET SCHEMA
/////////////////////////////////////////

export const NotifyGeotargetSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  contentId: z.bigint(),
  featureId: z.number().int(),
})

export type NotifyGeotarget = z.infer<typeof NotifyGeotargetSchema>

export default NotifyGeotargetSchema;
